import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'proposalStatus'
})
export class ProposalStatusPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    switch (value) {
      case 'pending': {
        return 'Oczekujące';
      }
      case 'changesugestion': {
        return 'Zmiana godziny';
      }
      case 'accepted': {
        return 'Zaakceptowane';
      }
      case 'rejected': {
        return 'Odrzucone';
      }
      default: {
        return '';
      }
    }
  }

}
